import {
  Switch as MuiSwitch,
  FormControlLabel,
  FormControlLabelProps,
} from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

type CustomFormControlLabelProps = Omit<FormControlLabelProps, 'control'>;

export interface SwitchProps extends CustomFormControlLabelProps {
  className?: string;
}

const SwitchImpl = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, color, ...props }: SwitchProps, ref) => {
    return (
      <FormControlLabel
        className={className}
        ref={ref}
        control={<MuiSwitch />}
        {...props}
      />
    );
  }
);

export const Switch = muiStyled(SwitchImpl)(({ theme, color }) => {
  const { disabledOpacity } = theme.palette.action;
  return css`
    &.MuiFormControlLabel-root {
      :hover {
        opacity: 0.8;
      }

      &.Mui-disabled {
        opacity: ${disabledOpacity};
      }

      .MuiFormControlLabel-label {
        color: ${theme.palette.text.secondary};
      }

      & .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
        background-color: ${color};
      }

      & .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb {
        background-color: ${color};
      }

      & .MuiSwitch-switchBase + .MuiSwitch-track {
        background-color: ${theme.palette.grey[400]};
      }

      & .MuiSwitch-switchBase .MuiSwitch-thumb {
        background-color: white;
      }
    }
  `;
});

export default Switch;
